import { Breadcrumb } from "antd";
import React from "react";
import { NavLink } from "react-router-dom";

const TreatmentCreateFilter = () => {
  return (
    <>
      <div className="d-flex ms-3 justify-content-between filter-bar">
        <div className="title-detail">
          <Breadcrumb
            items={[
              {
                title: <NavLink to="/treatment-plans">Treatment Plans</NavLink>,
              },
              {
                title: "Create Proposal",
              },
            ]}
          />
          <h1 className="fw-bold">Treatment Plan Template</h1>
        </div>
      </div>
    </>
  );
};

export default TreatmentCreateFilter;
